module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon4.0315e62a.png";